import * as THREE from "three/webgpu";

/**
 * Deterministic FNV-1a hash of a scene-object ID into a distinguishable color.
 * Used by selection-outline and inking prepasses to identify objects on the GPU.
 */
export function hashObjectIdToColor(objectId: string): THREE.Color {
  let hash = 2166136261;
  for (let i = 0; i < objectId.length; i++) {
    hash ^= objectId.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  const rgb = ((hash >>> 0) & 0x00ffffff) | 0x202020;
  const color = new THREE.Color(rgb);
  if (color.r + color.g + color.b < 0.35) {
    color.r += 0.2;
    color.g += 0.2;
    color.b += 0.2;
  }
  return color;
}
